import { Injectable } from '@angular/core';
import { IActivityDto } from 'core/dto';
import { Observable } from 'rxjs';
import { ApiService } from '../api.service';
import { controllerEndpoints } from '../controller.endpoints';
import { crudEndpoints } from '../crud.endpoints';
import { customEndpoints } from '../custom.endpoints';
import joinUrls from '../utils.ts/join-urls';
import { ICrudAdvancedMethods } from './types/i-crud-advanced.methods';
import { ICrudBasicMethods } from './types/i-crud-basic.methods';
import { IGetByProcess } from './types/i-get-by-process';

@Injectable({
  providedIn: 'root'
})
export class ActivityRemoteControllerService implements
  ICrudBasicMethods<IActivityDto>,
  IGetByProcess<IActivityDto>,
  Pick<ICrudAdvancedMethods<IActivityDto>, 'reorder'>
{

  private readonly _endpoint = controllerEndpoints.ACTIVITY;

  private readonly _getForUserByProcessIdEndpoint = 'getForUserByProcessId'
  private readonly _finishEndpoint = 'finish'
  private readonly _rejectEndpoint = 'reject'
  private readonly _canFinishEndpoint = 'canFinish'

  constructor(
    private readonly _apiService: ApiService
  ) { }

  getByProcess(processId: string): Observable<IActivityDto[]> {
    const getByProcessEndpoint = joinUrls(this._endpoint, customEndpoints.GET_BY_PROCESS_ID, processId);
    return this._apiService.get<IActivityDto[]>(getByProcessEndpoint)
  }

  getOne(id: string): Observable<IActivityDto> {
    const getOneEndpoint = joinUrls(this._endpoint, id)
    return this._apiService.get(getOneEndpoint)
  }

  update(id: string, updateDto: Partial<IActivityDto>): Observable<IActivityDto> {
    return this._apiService.put<IActivityDto>(this._endpoint, updateDto, { id })
  }

  create(createDto: Partial<IActivityDto>): Observable<IActivityDto> {

    return this._apiService.post(this._endpoint, createDto)
  }

  remove(id: string): Observable<undefined> {

    const removeEndpoint = joinUrls(this._endpoint, id);
    return this._apiService.delete<undefined>(removeEndpoint)
  }

  reorder(reorderPairs: { orderIndex: number, id: string }[], processId: string): Observable<undefined> {
    const reorderEndpoint = joinUrls(this._endpoint, crudEndpoints.REORDER, processId)
    return this._apiService.put<undefined>(reorderEndpoint, reorderPairs);
  }

  getForUserByProcessId(processId: string) {
    const getForUserByProcessIdEndpoint = joinUrls(this._endpoint, this._getForUserByProcessIdEndpoint, processId)
    return this._apiService.get<IActivityDto>(getForUserByProcessIdEndpoint);
  }

  reject(activityId: string, reason: string) {
    const rejectEndpoint = joinUrls(this._endpoint, this._rejectEndpoint, activityId)
    return this._apiService.put<IActivityDto>(rejectEndpoint, { reason });
  }

  finish(activityId: string) {
    const finishEndpoint = joinUrls(this._endpoint, this._finishEndpoint, activityId)
    return this._apiService.put<IActivityDto>(finishEndpoint);
  }

  canFinish(activityId: string) {
    const canFinishEndpoint = joinUrls(this._endpoint, this._canFinishEndpoint, activityId)
    return this._apiService.get<{ canFinish: boolean, canDownload: boolean }>(canFinishEndpoint);
  }


}
